import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { OrderStatus } from 'interfaces';

export const ORDER_STATUSES: Record<OrderStatus, OrderStatus> = {
   WAITING: 'WAITING',
   IN_PROGRESS: 'IN_PROGRESS',
   DELIVERED: 'DELIVERED',
   DURING_BILLING: 'DURING_BILLING',
   TO_PAY: 'TO_PAY',
   ENDED: 'ENDED',
   CANCELED: 'CANCELED',
};

export const useOrderStatuses = () => {
   const { t } = useTranslation();

   const orderStatusesLegend: {
      status: string;
      description: string;
      variant: OrderStatus;
   }[] = useMemo(
      () => [
         {
            status: t('order.status.waiting'),
            description: t('order.statusLegend.waiting'),
            variant: 'WAITING',
         },
         {
            status: t('order.status.in_progress'),
            description: t('order.statusLegend.in_progress'),
            variant: 'IN_PROGRESS',
         },
         {
            status: t('order.status.delivered'),
            description: t('order.statusLegend.delivered'),
            variant: 'DELIVERED',
         },
         {
            status: t('order.status.during_billing'),
            description: t('order.statusLegend.during_billing'),
            variant: 'DURING_BILLING',
         },
         {
            status: t('order.status.to_pay'),
            description: t('order.statusLegend.to_pay'),
            variant: 'TO_PAY',
         },
         {
            status: t('order.status.ended'),
            description: t('order.statusLegend.ended'),
            variant: 'ENDED',
         },
         {
            status: t('report_statuses.canceled'),
            description: t('order.statusLegend.canceled'),
            variant: 'CANCELED',
         },
      ],
      [t],
   );

   const ORDER_STATUSES_BADGE_DATA: {
      [key in OrderStatus]: { label: string; variant: OrderStatus };
   } = useMemo(
      () => ({
         WAITING: { label: t('order.status.waiting'), variant: 'WAITING' },
         CANCELED: { label: t('report_statuses.canceled'), variant: 'CANCELED' },
         DURING_BILLING: { label: t('order.status.during_billing'), variant: 'DURING_BILLING' },
         TO_PAY: { label: t('order.status.to_pay'), variant: 'TO_PAY' },
         ENDED: { label: t('order.status.ended'), variant: 'ENDED' },
         IN_PROGRESS: { label: t('order.status.in_progress'), variant: 'IN_PROGRESS' },
         DELIVERED: { label: t('order.status.delivered'), variant: 'DELIVERED' },
      }),
      [t],
   );

   return { orderStatusesLegend, ORDER_STATUSES_BADGE_DATA, ORDER_STATUSES };
};
